import { FC } from 'react';
import styles from './IFrame.module.scss';

interface IFrameProps {
    src: string;
    title?: string;
    className?: string;
}

export const IFrame: FC<IFrameProps> = ({ src, title, className }) => {
    return (
        <iframe
            src={src}
            title={title}
            className={`${styles.iframe} ${className || ''}`}
            allow="fullscreen; microphone; camera; autoplay; clipboard-write"
            sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-forms allow-modals allow-presentation allow-same-origin allow-top-navigation"
        />
    );
};
